import {Component, Input} from "@angular/core";

@Component({
  selector: "core-input-child",
  template: `
    <p>{{ text }}</p>
  `
})
class InputChildComponent {
  @Input() text: string;
}

@Component({
  selector: "core-input",
  template: `
  <usecase-container title="Input" src="core/input">
    <usecase-content>
      <core-input-child [text]="'Angular 2'"></core-input-child>
    </usecase-content>
  </usecase-container>
  `,
  directives: [InputChildComponent]
})
export class InputComponent {
}



/** WEBPACK FOOTER **
 ** ./script/core/input/component.ts
 **/